var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#E3E7EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.469 212.48C183.469 172.421 215.943 139.947 256.003 139.947C296.062 139.947 328.536 172.421 328.536 212.48C328.536 252.539 296.062 285.013 256.003 285.013C215.943 285.013 183.469 252.539 183.469 212.48ZM256.003 256C280.038 256 299.523 236.516 299.523 212.48C299.523 188.445 280.038 168.96 256.003 168.96C231.967 168.96 212.483 188.445 212.483 212.48C212.483 236.516 231.967 256 256.003 256Z",
    fill: "#ADB3BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.94 289.991C152.176 311.756 139.949 341.274 139.949 372.053H168.963C168.963 348.969 178.133 326.83 194.456 310.507C210.779 294.184 232.918 285.013 256.003 285.013C279.087 285.013 301.226 294.184 317.549 310.507C333.872 326.83 343.043 348.969 343.043 372.053H372.056C372.056 341.274 359.829 311.756 338.065 289.991C316.3 268.227 286.782 256 256.003 256C225.223 256 195.705 268.227 173.94 289.991Z",
    fill: "#ADB3BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user_default.47055b05754e34064e77abfd6efbbddb.svg";
export { ForwardRef as ReactComponent };